import { render, staticRenderFns } from "./SchemaForm.vue?vue&type=template&id=6a4705d3&scoped=true&"
import script from "./SchemaForm.vue?vue&type=script&lang=js&"
export * from "./SchemaForm.vue?vue&type=script&lang=js&"
import style0 from "./SchemaForm.vue?vue&type=style&index=0&id=6a4705d3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4705d3",
  null
  
)

export default component.exports